import styled from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Title = styled.h1`
  ${({ theme }) => theme.typos.pageHeader};
  margin: 30px 0;
`;
